import { render, staticRenderFns } from "./TutorVideoReport.vue?vue&type=template&id=5a5328c6"
import script from "./TutorVideoReport.vue?vue&type=script&lang=js"
export * from "./TutorVideoReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports